import { Action } from 'redux';
import { About, CheckSelfInfo, AASTheme, User } from '../../clients/aasServerClient.generated';
import { State } from './state';

export enum ActionTypeNames {
    CheckLogin = 'Auth/CheckLogin',
    GetLoginInfo = 'Auth/GetLoginInfo',
    FetchAllData = 'Auth/FetchAllData',
    Login = 'Auth/Login',
    Logout = 'Auth/Logout',
    LoginAs = 'Auth/LoginAs',
    LogoutAs = 'Auth/LogoutAs',
    UpdateAccount = 'Auth/UpdateAccount',
    GetTheme = 'Auth/GetTheme',
    GetAbout = 'Auth/GetAbout',
    GetSessions = 'Auth/GetSessions',
    GetSelfInfo = 'Auth/GetSelfInfo',

    SendPasswordReset = 'Auth/SendPasswordReset',
    ResetPassword = 'Auth/ResetPassword',
    CheckResetPasswordToken = 'Auth/CheckResetPasswordToken',
    ConfirmActiveDirectory = 'Auth/ConfirmActiveDirectory',
    VerifyEmail = 'Auth/VerifyEmail',

    SetInvalidToken = 'Auth/SetInvalidToken',
    InvalidTokenClear = 'Auth/InvalidTokenClear',

    DialogSuccess = 'Auth/DialogSuccess',
    DialogClear = 'Auth/DialogClear',

    AuthenticationStateChanged = 'Auth/AuthenticationStateChanged',
    SetTheme = 'Auth/SetTheme',
    SetAbout = 'Auth/SetAbout',
    SetSessions = 'Auth/SetSessions',
    SetSelfInfo = 'Auth/SetSelfInfo',

    GoToApplication = 'Auth/GoToApplication',
    ResetLoadingApplication = 'Auth/ResetLoadingApplication',
    AnonymousLogin = 'Auth/AnonymousLogin',
    GoToZendesk = 'Auth/GoToZendesk',
    SetAuthReqSource = 'Auth/SetAuthReqSource',
}

export type CheckLoginAction = Action<ActionTypeNames.CheckLogin>;
export type GetLoginInfoAction = Action<ActionTypeNames.GetLoginInfo>;
export type FetchAllDataAction = Action<ActionTypeNames.FetchAllData>;
export type GetThemeAction = Action<ActionTypeNames.GetTheme>;
export type GetAboutAction = Action<ActionTypeNames.GetAbout>;
export type GetSessionsAction = Action<ActionTypeNames.GetSessions>;
export type GetSelfInfoAction = Action<ActionTypeNames.GetSelfInfo>;

export type LoginAction = Action<ActionTypeNames.Login> & {
    email: string,
    password: string,
    remember_me: boolean,
    task: string,
    url: string,
    application: string,
    queryString: string,
};

export type LogoutAction = Action<ActionTypeNames.Logout>;

export type LoginAsAction = Action<ActionTypeNames.LoginAs> & {
    id: string,
    refreshTable?: boolean,
};

export type SendPasswordResetAction = Action<ActionTypeNames.SendPasswordReset> & {
    email: string,
};
export type ResetPasswordAction = Action<ActionTypeNames.ResetPassword> & {
    id: string,
    token: string,
    new_password: string,
    confirm_new_password: string,
};

export type CheckResetPasswordTokenAction = Action<ActionTypeNames.CheckResetPasswordToken> & {
    id: string,
    token: string,
};

export type ConfirmActiveDirectoryAction = Action<ActionTypeNames.ConfirmActiveDirectory> & {
    id: string,
    token: string,
};

export type VerifyEmailAction = Action<ActionTypeNames.VerifyEmail> & {
    id: string,
    token: string,
}

export type SetInvalidTokenAction = Action<ActionTypeNames.SetInvalidToken> & {
    invalidToken: boolean;
};
export type InvalidTokenClearAction = Action<ActionTypeNames.InvalidTokenClear>;

export type DialogSuccessAction = Action<ActionTypeNames.DialogSuccess>;
export type DialogClearAction = Action<ActionTypeNames.DialogClear>;

export type LogoutAsAction = Action<ActionTypeNames.LogoutAs> & {
    checkSelf?: boolean;
    refreshTable?: boolean;
};

export type AuthenticationStateChangedAction = Action<ActionTypeNames.AuthenticationStateChanged> & {
    newState: Partial<State>
};

export type SetThemeAction = Action<ActionTypeNames.SetTheme> & {
    theme: AASTheme;
};
export type SetAboutAction = Action<ActionTypeNames.SetAbout> & {
    about: About;
};

export type SetSessionsAction = Action<ActionTypeNames.SetSessions> & {
    sessions: User[];
};

export type SetSelfInfoAction = Action<ActionTypeNames.SetSelfInfo> & {
    selfInfo: CheckSelfInfo;
};

export type GoToApplicationAction = Action<ActionTypeNames.GoToApplication> & {
    id: string;
};

export type ResetLoadingApplicationAction = Action<ActionTypeNames.ResetLoadingApplication>;

export type AnonymousLoginAction = Action<ActionTypeNames.AnonymousLogin> & {
    token: string;
};

export type GoToZendeskAction = Action<ActionTypeNames.GoToZendesk>;

export type UpdateAccountAction = Action<ActionTypeNames.UpdateAccount> & {
    email: string,
    confirmEmail: string,
    firstName: string,
    lastName: string,
};

export type SetAuthReqSourceAction = Action<ActionTypeNames.SetAuthReqSource> & {
    task: string;
    url: string;
    application: string;
    queryString: string;
}